<template>
  <div :class="{ 'hw-legend': !hasTotal }">
    <div v-for="item in items" :key="item.key" :class="hasTotal ? 'hw-legend-row' : 'hw-legend-item'">
      <span class="hw-dot" :style="{ backgroundColor: item.color }"></span>
      <span class="hw-ellipsis" :title="item.label">{{ item.label }}</span>
      <strong v-if="hasTotal" class="hw-num">{{ onlyCommaFormat(item.value) }}</strong>
      <span v-if="hasTotal" class="hw-pill" :style="pctStyle(item)">{{ percentLabel(item.value, total) }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import figureFormatter from '@/services/utils/figureFormatter'
import { pctStyle, percentLabel } from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/hrWorkforce'

const props = defineProps({
  items: { type: Array, required: true },
  total: { type: Number, default: null }
})

const { onlyCommaFormat } = figureFormatter()

const hasTotal = computed(() => props.total !== null)
</script>

<style scoped src="./hrWorkforce.css"></style>

<style scoped>
.hw-legend {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  font-size: 0.8rem;
  color: #64748b;
  margin-bottom: 10px;
}
.hw-legend-item {
  display: inline-flex;
  align-items: center;
  min-width: 0;
}
.hw-legend-row {
  display: grid;
  grid-template-columns: 12px minmax(0, 1fr) auto 52px;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  font-size: 0.85rem;
  color: #334155;
  border-bottom: 1px dashed #e2e8f0;
}
.hw-legend-row:last-child {
  border-bottom: 0;
}
.hw-legend-row .hw-dot {
  margin-right: 0;
}
</style>
